export default __webpack_public_path__ + "static/media/gif.32e76db1.svg";